import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'exists',
    standalone: false
})
export class ExistsPipe implements PipeTransform {
    transform(value: any, compareTo: boolean = true): boolean {
        return (value != null) === compareTo;
    }
}
